
let socket: WebSocket | null = null;

export const connectWebSocket = (onMessage: (data: any) => void) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    return;
  }
  const baseUrl = process.env.REACT_APP_BASE_URL || "https://api.kauaismart.com.br";

  const ws_url = `${baseUrl.replace('https', 'wss')}/ws/orders` 
  socket = new WebSocket(ws_url);

  socket.onopen = () => {
    console.log("Conectado ao WebSocket");
  };

  socket.onmessage = (event) => {
    const data = JSON.parse(event.data);
    console.log("Atualização na fila:", data);
    onMessage(data);
  };

  socket.onclose = () => {
    console.log("WebSocket desconectado. Tentando reconectar em 3 segundos...");
    setTimeout(() => connectWebSocket(onMessage), 3000);
  };

  socket.onerror = (error) => {
    console.error("Erro no WebSocket:", error);
  };
};

export const disconnectWebSocket = () => {
  if (socket) {
    socket.close();
    socket = null;
  }
};